 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"1453de412feb020d509f7ef8f3bc9769552001c2","3":"54b82ca6","4":"5938646d6718694ea02c555d1bb27b4085679dd1","5":"7653b4facc5a95689e17d87abf1503df73d7a136","6":"7b1715662ddf3f1d3bb50fa3fe518bed7d2658ac","7":"0bb0ca0496a479415c6a04a3c6a66f950aca4e86","8":"10efce380acb9244c1a5dd10c7ec6f8c99266722","9":"f3bc85ad","10":"3c91a2e1f14c379da605812e3759eb63ccf0d3ad","11":"66969e0afb053834ccb104c08f4c24f336f809c3","12":"15b7de433d8eb81c8e60d6c00569c8b157ac816c","13":"252f366e","14":"460585805e706babe8d927d1b40327540dbe8e1d","15":"73506f01a3757dc89b753d8ad3255380f44bbaea","16":"d6e89ca4ae801bbd9e2817233d0bb783f50e31ee","17":"0092281a179f575957877704e4d14668d896a316","18":"285519c9cfc9f196a8acf984e72e2dabdf127c13","22":"52066749","23":"5e2a4920","24":"8673774c","26":"cb54706e","27":"component---src-pages-404-js","28":"component---src-pages-about-js","29":"component---src-pages-app-js","30":"component---src-pages-blog-5-beautiful-color-palette-generators-for-your-next-design-project-js","31":"component---src-pages-blog-7-reasons-why-you-should-learn-music-theory-js","32":"component---src-pages-blog-cadences-js","33":"component---src-pages-blog-dont-give-up-on-music-theory-js","34":"component---src-pages-blog-how-to-find-new-music-js","35":"component---src-pages-blog-how-to-learn-music-theory-js","36":"component---src-pages-blog-index-js","37":"component---src-pages-blog-is-betapage-worth-it-js","38":"component---src-pages-blog-suno-ai-chord-progressions-js","39":"component---src-pages-blog-suno-ai-prompt-guide-js","40":"component---src-pages-blog-suno-ai-tips-js","41":"component---src-pages-blog-suno-vs-udio-js","42":"component---src-pages-blog-the-4-best-ear-training-apps-for-2019-js","43":"component---src-pages-blog-whats-new-in-solfej-v-1-3-js","44":"component---src-pages-chords-index-js","45":"component---src-pages-index-js","46":"component---src-pages-privacy-js","47":"component---src-pages-scales-index-js","48":"component---src-pages-terms-of-service-js","49":"component---src-templates-blog-index-translated-js","50":"component---src-templates-chord-page-chord-page-js","51":"component---src-templates-chord-search-translated-js","52":"component---src-templates-homepage-translated-js","53":"component---src-templates-scale-page-scale-page-js","54":"component---src-templates-scale-search-translated-js","55":"component---src-templates-suno-blog-post-js"}[chunkId]||chunkId) + "-" + {"0":"5214b1ad6af4a0e295f1","1":"29147cbc04bbc833f6a0","2":"5a5dfdf9e1f4f686eeaa","3":"65e66f3f2fcdf5a3b019","4":"47651159fd50af7ed969","5":"0d4494e091b31b22d7f0","6":"eddd9f086d0fd43c54db","7":"c247bd01b2a266cea17a","8":"ce5bf96d7faf259546f3","9":"af7ec7e7f64b174537ce","10":"3b13abee23a28d3f3422","11":"e8356c14373ac731abda","12":"4216e5544f18bdd82059","13":"60368f0d080a8c4e24a7","14":"a1e0a93fff5b4f65109d","15":"173fc3e932f621ec204d","16":"a479e1a1a2b69d1d3cb8","17":"beb5228b18d057040f6e","18":"dbc75c2fe2f3a3e7526e","20":"2796e9aeefae3670cb10","21":"b9eef6f668b504013392","22":"69f7350f86b7524ecf49","23":"6065ddf1d0d7063ebe00","24":"b87644b7e8ad6336ae85","26":"37833b04a63494d8bc9a","27":"e6a7781a932c95fd49d8","28":"8488e10c7a6befe5efa3","29":"c6ffe29e4f8a57cdefc7","30":"976f56f5af7c0b888042","31":"533ea0f20fca0f950a22","32":"20c3af78bf6fc653c7f0","33":"eb4bed5d38e9626dcc57","34":"387b8d6b8e49529b7925","35":"ccfa61270b4def6ce244","36":"da7abb46a041415f1236","37":"d5e1f2834e78f95c72e0","38":"4a421d8c36748b677d7c","39":"3cc4a1d8f88cf2995b2d","40":"94b42c4031187b2c59ea","41":"9d5e32e232ba572c25b7","42":"7a086d18f34e37a64db9","43":"d3f560bd2a6a4397a37a","44":"605725fc0fd07401c50e","45":"c0a1aadbeff3f547f2f5","46":"222caa386d57b3cb70eb","47":"b5c450f1df386d50f9a4","48":"5fd4d712f7031005f4bb","49":"777011d14c6d32a6f448","50":"a05146100e0332f215c4","51":"26bc3ead467b52f4b778","52":"387634bccf58d8d5058c","53":"52b0fa816969f7847c9f","54":"1faa376819f366bf3ab2","55":"537d25c43aa090dab652","58":"97c911405f7054602bf3","59":"ece3187e8c6491ddd4b3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"1453de412feb020d509f7ef8f3bc9769552001c2","3":"54b82ca6","4":"5938646d6718694ea02c555d1bb27b4085679dd1","5":"7653b4facc5a95689e17d87abf1503df73d7a136","6":"7b1715662ddf3f1d3bb50fa3fe518bed7d2658ac","7":"0bb0ca0496a479415c6a04a3c6a66f950aca4e86","8":"10efce380acb9244c1a5dd10c7ec6f8c99266722","9":"f3bc85ad","10":"3c91a2e1f14c379da605812e3759eb63ccf0d3ad","11":"66969e0afb053834ccb104c08f4c24f336f809c3","12":"15b7de433d8eb81c8e60d6c00569c8b157ac816c","13":"252f366e","14":"460585805e706babe8d927d1b40327540dbe8e1d","15":"73506f01a3757dc89b753d8ad3255380f44bbaea","16":"d6e89ca4ae801bbd9e2817233d0bb783f50e31ee","17":"0092281a179f575957877704e4d14668d896a316","18":"285519c9cfc9f196a8acf984e72e2dabdf127c13","22":"52066749","23":"5e2a4920","24":"8673774c","26":"cb54706e","27":"component---src-pages-404-js","28":"component---src-pages-about-js","29":"component---src-pages-app-js","30":"component---src-pages-blog-5-beautiful-color-palette-generators-for-your-next-design-project-js","31":"component---src-pages-blog-7-reasons-why-you-should-learn-music-theory-js","32":"component---src-pages-blog-cadences-js","33":"component---src-pages-blog-dont-give-up-on-music-theory-js","34":"component---src-pages-blog-how-to-find-new-music-js","35":"component---src-pages-blog-how-to-learn-music-theory-js","36":"component---src-pages-blog-index-js","37":"component---src-pages-blog-is-betapage-worth-it-js","38":"component---src-pages-blog-suno-ai-chord-progressions-js","39":"component---src-pages-blog-suno-ai-prompt-guide-js","40":"component---src-pages-blog-suno-ai-tips-js","41":"component---src-pages-blog-suno-vs-udio-js","42":"component---src-pages-blog-the-4-best-ear-training-apps-for-2019-js","43":"component---src-pages-blog-whats-new-in-solfej-v-1-3-js","44":"component---src-pages-chords-index-js","45":"component---src-pages-index-js","46":"component---src-pages-privacy-js","47":"component---src-pages-scales-index-js","48":"component---src-pages-terms-of-service-js","49":"component---src-templates-blog-index-translated-js","50":"component---src-templates-chord-page-chord-page-js","51":"component---src-templates-chord-search-translated-js","52":"component---src-templates-homepage-translated-js","53":"component---src-templates-scale-page-scale-page-js","54":"component---src-templates-scale-search-translated-js","55":"component---src-templates-suno-blog-post-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"c33361ba8a95119c9ddd","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
